export class Fragmento {
	idFragmento: number;
	idRecurso: number;
	fragmento: string;
	dispositivo: string;
	ordemExibicaoFragmento: number;

	constructor (fragmento: string,
		dispositivo: string,
		ordemExibicaoFragmento: number) {
			this.fragmento = fragmento;
			this.dispositivo = dispositivo;
			this.ordemExibicaoFragmento = ordemExibicaoFragmento;
		}
}
